import { render, staticRenderFns } from "./NoWebhooks.vue?vue&type=template&id=fd0fbd4a&"
import script from "./NoWebhooks.vue?vue&type=script&lang=js&"
export * from "./NoWebhooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports